import React from "react";
import { MoreVerticalIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/Button";

export interface ChartActionsButtonProps {
  disabled?: boolean;
  className?: string;
}

export const ChartActionsButton: React.FC<ChartActionsButtonProps> = ({
  disabled,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      size="icon"
      className={`size-8 text-muted-foreground data-[state=open]:bg-muted ${
        disabled ? "cursor-not-allowed hover:cursor-not-allowed" : ""
      }`}
      data-testid="chart-actions-button"
      disabled={disabled}
      {...rest}
    >
      <MoreVerticalIcon className="h-7 w-7 text-primary" />
      <span className="sr-only">{t("aria.openMenu")}</span>
    </Button>
  );
};
